// SPRAYVERSE blog — small progressive enhancements. Everything renders without JS.
(function () {
  // Rail arrows (desktop): scroll one card at a time, disable at the ends
  document.querySelectorAll('[data-sv-rail]').forEach(function (rail) {
    var id = rail.getAttribute('data-sv-rail');
    var prev = document.querySelector('[data-sv-rail-prev="' + id + '"]');
    var next = document.querySelector('[data-sv-rail-next="' + id + '"]');
    if (!prev || !next) return;
    function step() {
      var card = rail.children[0];
      return card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
    }
    function sync() {
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  // "Load more stories": fetch the next blog page and append its cards.
  // Without JS the button is a plain link to ?page=N.
  var more = document.querySelector('[data-sv-more]');
  var grid = document.querySelector('[data-sv-grid]');
  if (more && grid && window.fetch && window.DOMParser) {
    more.addEventListener('click', function (event) {
      event.preventDefault();
      var url = more.getAttribute('href');
      if (!url || more.getAttribute('aria-busy') === 'true') return;
      more.setAttribute('aria-busy', 'true');
      var label = more.textContent;
      more.textContent = 'Loading…';
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = page.querySelector('[data-sv-grid]');
          if (nextGrid) {
            Array.prototype.forEach.call(nextGrid.children, function (card) {
              grid.appendChild(document.importNode(card, true));
            });
          }
          var nextMore = page.querySelector('[data-sv-more]');
          if (nextMore) {
            more.setAttribute('href', nextMore.getAttribute('href'));
            more.textContent = label;
            more.removeAttribute('aria-busy');
          } else {
            more.closest('.sv-load-more').hidden = true;
          }
        })
        .catch(function () {
          // Fall back to a normal page visit
          window.location.href = url;
        });
    });
  }

  // Sticky "Shop the story" bar on mobile: show after the hero, hide over the shop block
  var bar = document.querySelector('[data-sv-shopbar]');
  var hero = document.querySelector('[data-sv-hero]');
  var shop = document.querySelector('#sv-shop');
  if (bar && hero && 'IntersectionObserver' in window) {
    var pastHero = false, shopVisible = false;
    function update() { bar.classList.toggle('sv-show', pastHero && !shopVisible); }
    new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; update(); }).observe(hero);
    if (shop) new IntersectionObserver(function (e) { shopVisible = e[0].isIntersecting; update(); }).observe(shop);
  }

  // Copy link
  document.querySelectorAll('[data-sv-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var label = btn.textContent;
      function ok() { btn.textContent = 'Link copied'; setTimeout(function () { btn.textContent = label; }, 1800); }
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(ok, function () {});
    });
  });
})();
